import React, { ReactElement } from 'react'
import ActionToggle from 'live/components/ui/action-toggle'

type Props = {
    value: boolean
    onChange: (value: boolean) => void
    label: string
}

export default function Toggle(props: Props): ReactElement {
    return (
        <div className="config-form is-checkbox verticalEnabled action-toogle ">
            <ActionToggle onChange={() => props.onChange(!props.value)} active={props.value} />
            {props.label}
        </div>
    )
}
